export default __webpack_public_path__ + "static/media/a8.6e3e915c.png";